import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IFcDropdownSelectOption } from "../form-controls/dropdown-select/fc-dropdown-select-option";
import { FormControl, FormGroup } from "@angular/forms";
import {TextUtils} from "../../../shared/utils/text-utils";

@Component({
    selector: 'db-schedule',
    templateUrl: './schedule.component.html',
    styleUrls: ['./schedule.component.scss'],
    standalone: false
})
export class ScheduleComponent implements OnInit {

  @Input() title?: string;
  @Input() cron_expression: string;
  @Output() cronExpressionString = new EventEmitter<any>();

  public slider: any;
  public sliderValues: any;
  public scheduleSettings: FormGroup;
  public settingsMonthDayOptions: IFcDropdownSelectOption[];
  public settingsMonthDay: FormControl;
  public settingsWeekDayOptions: IFcDropdownSelectOption[];
  public settingsWeekDay: FormControl;
  public settingsStartTimeOptions: IFcDropdownSelectOption[];
  public settingsStartTime: FormControl;

  constructor(
  ) {
    this.cronExpressionString = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.slider = 1;
    this.settingsMonthDay = new FormControl(1);
    this.settingsStartTime = new FormControl('00:00');
    this.settingsWeekDay = new FormControl(1);
    this.scheduleSettings = new FormGroup({
      'settingsMonthDay':  this.settingsMonthDay,
      'settingsStartTime':  this.settingsStartTime,
      'settingsWeekDay':  this.settingsWeekDay,
    });
    const settingsMonthDayOptions = [];
    for (let i = 1; i <= 31; i++) {
      settingsMonthDayOptions.push({
        "label": i.toString(),
        "value": i
      });
    }
    this.settingsMonthDayOptions = settingsMonthDayOptions;
    const settingsStartTimeOptions = [];
    let val;
    for (let i = 0; i <= 23; i++) {
      val = ('0' + i).slice(-2) + ":00";
      settingsStartTimeOptions.push({
        "label": val,
        "value": val
      });
    }
    this.settingsStartTimeOptions = settingsStartTimeOptions;
    this.settingsWeekDayOptions = [
      {
        "label": TextUtils.getText('text_monday'),
        "value": 1
      },
      {
        "label": TextUtils.getText('text_tuesday'),
        "value": 2
      },
      {
        "label": TextUtils.getText('text_wednesday'),
        "value": 3
      },
      {
        "label": TextUtils.getText('text_thursday'),
        "value": 4
      },
      {
        "label": TextUtils.getText('text_friday'),
        "value": 5
      },
      {
        "label": TextUtils.getText('text_saturday'),
        "value": 6
      },
      {
        "label": TextUtils.getText('text_sunday'),
        "value": 7
      },
    ];

    this.sliderValues = [
      {
        title: TextUtils.getText('text_periodMonthly'),
      },
      {
        title: TextUtils.getText('text_periodWeekly'),
      },
      {
        title: TextUtils.getText('text_periodDaily'),
      },
    ];
    this.setScheduleData();
    this.editSchedule();
    this.settingsStartTime.valueChanges.subscribe((val: any) => {
      this.editSchedule();
    });
    this.settingsMonthDay.valueChanges.subscribe((val: any) => {
      this.editSchedule();
    });
    this.settingsWeekDay.valueChanges.subscribe((val: any) => {
      this.editSchedule();
    });
  }

  public setSliderValue(value) {
    this.slider = value;
  }

  public onChange(e) {
    this.editSchedule();
  }

  private setScheduleData () {
    this.parseCronExpression(this.cron_expression);
  }

  public editSchedule () {
    this.cronExpressionString.emit(this.generateCronExpression());
  }


  public generateCronExpression() {
    let cronExpression = "";
    let startTimeArray = "";
    switch (this.slider) {
      case 0:
        startTimeArray = this.scheduleSettings.controls['settingsStartTime'].value.split(":");
        const monthDayArray = this.scheduleSettings.controls['settingsMonthDay'].value;
        cronExpression = startTimeArray[1] + " " + startTimeArray[0] + " " + monthDayArray + " " + "*" + " " + "*";
        return cronExpression;
      case 1:
        startTimeArray = this.scheduleSettings.controls['settingsStartTime'].value.split(":");
        const weekDayArray = this.scheduleSettings.controls['settingsWeekDay'].value;
        cronExpression = startTimeArray[1] + " " + startTimeArray[0] + " " + "*" + " " + "*" + " " + weekDayArray;
        return cronExpression;
      case 2:
        startTimeArray = this.scheduleSettings.controls['settingsStartTime'].value.split(":");
        cronExpression = startTimeArray[1] + " " + startTimeArray[0] + " " + "*" + " " + "*" + " " + "*";

        return cronExpression;
    }
    return null;
  }


  public parseCronExpression(cron) {
    if ( cron ) {
      let startTime;
      if ( cron[2] !== "*" ) {
        startTime = cron.split("/")[0].split(" ")[1] + ":" + cron.split("/")[0].split(" ")[0];
        if ( cron.indexOf("/12") > -1 || cron.indexOf("/6") > -1 ) {
          if ( cron.indexOf("/12") > -1 ) {
            this.slider = 3;
          }
          else {
            this.slider = 4;
          }
        }
        else {
          if ( (cron[6] !== "*" && cron[8] === "*" && cron[10] === "*") || (cron[6] !== "*" && cron[9] === "*" && cron[11] === "*")) {
            this.slider = 0;
            const monthDay = Number(cron.split(" ")[2]);
            this.settingsMonthDay.setValue(monthDay);
          }
          else if ( cron[6] === "*" && cron[8] === "*" &&  cron[10] !== "*" ) {
            this.slider = 1;
            const weekDay = Number(cron.split(" ")[4]);
            this.settingsWeekDay.setValue(weekDay);
          }
          else if ( (cron.match(/\*/g)).length === 3 ) {
            this.slider = 2;
          }
        }
      }
      this.settingsStartTime.setValue(startTime);
    }

  }
}
